import { useMutation, useQueryClient } from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import {
  UpdateNotificationDTO,
  UserApiService,
} from 'features/users/api/user-api.service';

import { userQueryKeys } from './query-keys';

const { updateNotification } = UserApiService();

export const UpdateNotification = () => {
  const { message } = App.useApp();
  const queryClient = useQueryClient();

  return useMutation(
    (payload: UpdateNotificationDTO) => {
      return updateNotification(payload);
    },
    {
      onError: (error) => {
        const uiMessage = handleError(error);

        message.error(uiMessage);
      },
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: userQueryKeys.lists(),
        });
        message.success('Notification clear');
      },
    },
  );
};
